@if(service.viewDroplistItems.length){
<div class="volunteering-prospects-views-part">

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='uniqueId' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.PotentialVolunteers) {
	<potential-volunteers-view-part></potential-volunteers-view-part>
	}
	@case (service.viewId.RecentlyClosed) {
	<recently-closed-view-part></recently-closed-view-part>
	}
	@case (service.viewId.AllClosed) {
	<all-closed-view-part></all-closed-view-part>
	}
	}
	}

</div>
}